<template>
    <div class="feedback-problem">
        <body-feedback
            :beforeBold="$t('components.feedback.problem.beforeBold')"
            :titleBold="$t('components.feedback.problem.titleBold')"
            :afterBold="$t('components.feedback.problem.afterBold')"
            actionName="sendProblem">
            <option-select 
                :options="options"
                typeOption="check"
                itemName="problem"
                :selectMore="true">
            </option-select>
        </body-feedback>
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import OptionSelect from '../../components/shared/default/OptionSelect.vue'
import { Bus } from '../../event-bus.js'
export default {
    components : {
        BodyFeedback,
        OptionSelect
    },
    data(){
        return{
            options : [
                { 
                    value : 0, 
                    text: this.$t("components.feedback.problem.options[0]")
                },
                {
                    value : 1,
                    text: this.$t("components.feedback.problem.options[1]")
                },
                {
                    value : 2,
                    text: this.$t("components.feedback.problem.options[2]")
                },
                {
                    value : 3,
                    text: this.$t("components.feedback.problem.options[3]")
                },
                {
                    value : 4,
                    text: this.$t("components.feedback.problem.options[4]")
                }
            ]
        }
    },
    created(){
        Bus.$on('sendProblem', this.sendProblem)
    },
    methods:{
        sendProblem(){
            Bus.$emit('nextStep')
            this.$router.push('/feedback-explain')
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
